import React from 'react';
import SupplierLayout from '../../layouts/SupplierLayout';
import Profile from '../../components/supplier/Profile';

const ProfilePage = () => {
	return (
		<SupplierLayout>
			<Profile />
		</SupplierLayout>
	);
};

export default ProfilePage;
